var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWalletConnectLogo = function SvgWalletConnectLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23024D",
    d: "M8.312 12.659c6.474-6.212 16.969-6.212 23.451 0l.779.746a.767.767 0 0 1 0 1.124l-2.663 2.56a.426.426 0 0 1-.587 0l-1.072-1.025c-4.514-4.333-11.842-4.333-16.356 0l-1.148 1.1a.426.426 0 0 1-.586 0l-2.672-2.56a.767.767 0 0 1 0-1.125zm29.054 5.493 2.387 2.265c.33.31.33.81 0 1.12L28.98 31.767a.865.865 0 0 1-1.18 0l-7.652-7.261a.225.225 0 0 0-.296 0l-7.643 7.261a.865.865 0 0 1-1.18 0L.246 21.546a.76.76 0 0 1 0-1.12l2.387-2.266a.865.865 0 0 1 1.181 0l7.652 7.262c.084.073.21.073.295 0l7.643-7.262a.865.865 0 0 1 1.181 0l7.652 7.262c.084.073.21.073.295 0l7.652-7.262a.856.856 0 0 1 1.18-.008"
  })));
};
export default SvgWalletConnectLogo;